module.exports = __webpack_public_path__ + "img/plan_reservenat.2669dfca.jpg";